export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9899.d31dc83a.jpg";